import "./VendorKeyTile.scss";
import OpenAILogo from "../../../assets/icons/LogoOpenAI";
import AnthropicLogo from "../../../assets/icons/LogoAnthropic";
import AmazonLogo from "../../../assets/icons/LogoAmazon";

import Message from "../../../i18n/Message";
import label from "../../../i18n/label";
import { useIntl } from "react-intl";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CheckIcon from "../../../assets/icons/CheckIcon";
import Spinner from "../../../assets/icons/Spinner";
import { vendorKeySelectors } from "./store/vendorKeyReducer";
import {
  createVendorKey,
  updateVendorKey,
  deleteVendorKey,
} from "./store/vendorKeyActionCreators";

import "./VendorKeyTile.scss";
import Notify from "../../shared/Notify";
import TrashIcon from "../../../assets/icons/TrashIcon";

const getVendorLogo = (vendor) => {
  switch (vendor) {
    case "OPENAI":
      return <OpenAILogo size={36} />;
    case "ANTHROPIC":
      return <AnthropicLogo size={36} />;
    case "AMAZON":
      return <AmazonLogo size={36} />;
    case "NEBIUS":
      return <img src="/app/images/vendors/nebius-favicon.png" width={36} />;
    default:
      return "Unknown";
  }
};

const getVendorTitle = (vendor) => {
  switch (vendor) {
    case "OPENAI":
      return "OpenAI";
    case "ANTHROPIC":
      return "Anthropic";
    case "AMAZON":
      return "Amazon";
    case "NEBIUS":
      return "Nebius";
    case "META":
      return "Meta";
    default:
      return "Unknown";
  }
};

const VendorKeyTile = ({ vendorKey }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { workspaceId } = useParams();
  const keyList = useSelector(vendorKeySelectors.getList);

  const [key, setKey] = useState("");
  const [formElem, setFormElem] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // Find existing vendor key from the store
  const existingVendorKey = keyList?.find((k) => k.vendor === vendorKey);

  // Load the key value from store when keyList changes
  useEffect(() => {
    if (existingVendorKey?.content) {
      setKey(existingVendorKey.content);
    }
  }, [existingVendorKey]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (formElem) formElem.reportValidity();
    if (!key) return;

    if (key.indexOf("***") >= 0) {
      Notify.error(label(intl, "vendor_key_new_value_required"));
      return;
    }

    setIsSaving(true);

    const vendorKeyData = {
      vendor: vendorKey,
      content: key,
    };

    const onSuccess = () => {
      setIsSaving(false);
    };

    const onError = () => {
      setIsSaving(false);
    };

    if (existingVendorKey) {
      // Update existing vendor key
      dispatch(
        updateVendorKey(
          intl,
          workspaceId,
          existingVendorKey.uid,
          vendorKeyData,
          onSuccess,
          onError
        )
      );
    } else {
      // Create new vendor key
      dispatch(
        createVendorKey(intl, vendorKeyData, workspaceId, onSuccess, onError)
      );
    }
  };

  const onDelete = () => {
    if (!existingVendorKey) return;

    setIsDeleting(true);

    const onSuccess = () => {
      setIsDeleting(false);
      setKey("");
    };

    const onError = () => {
      setIsDeleting(false);
    };

    dispatch(
      deleteVendorKey(intl, workspaceId, existingVendorKey.uid, onSuccess, onError)
    );
  };

  return (
    <div className="vendor_key_tile d-flex">
      <div className="vendor_logo">{getVendorLogo(vendorKey)}</div>
      <div className="content_rows">
        <div className="vendor_title">{getVendorTitle(vendorKey)}</div>
        <div
          className="vendor_help"
          dangerouslySetInnerHTML={{
            __html: label(intl, "vendor_key_help." + vendorKey),
          }}
        >
          {/*<Message id={"vendor_key_help." + vendorKey} />*/}
        </div>
        <div className="vendor_form">
          <form onSubmit={onSubmit} ref={(val) => setFormElem(val)}>
            <input
              type="text"
              className="form-control"
              placeholder={label(intl, "vendor_key_placeholder")}
              value={key}
              onChange={(e) => setKey(e.target.value)}
              onFocus={() => setKey("")}
            />
            <div className="button_group">
              <button
                className="btn btn-outline-dark btn-sm"
                type="submit"
                disabled={isSaving || isDeleting}
              >
                {isSaving ? (
                  <Spinner size={18} color="#344767" />
                ) : (
                  <CheckIcon color="#344767" strokeWidth="2" size="18" />
                )}
                <Message id="save" />
              </button>
              {existingVendorKey && key && (
                <button
                  className="btn btn-outline-danger btn-sm"
                  type="button"
                  onClick={onDelete}
                  disabled={isSaving || isDeleting}
                >
                  {isDeleting ? (
                    <Spinner size={18} color="#dc3545" />
                  ) : (
                    <TrashIcon size={16} color="#dc3545" />
                  )}
                  <Message id="delete" />
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VendorKeyTile;
